import ReactPropTypesSecret from "../../node_modules/prop-types/lib/ReactPropTypesSecret";

class ValidationError {

}

const Validator = (typeSpecs, values, location, componentName) => {
    const errors = new ValidationError();
    for (let typeSpecName in typeSpecs) {
        if (typeSpecs.hasOwnProperty(typeSpecName)) {
            let error;
            // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    let err = Error(
                        (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
                        'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
                    );
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
                error = ex;
            }
            if (error) {
                errors[typeSpecName] = error;
            }
        }
    }
    if (Object.keys(errors).length) {
        errors.message = Object.entries(errors).map(e => e[1].message).join(", ");
        return errors;
    } else {
        return null;
    }
}

export default Validator;